module.exports = __webpack_public_path__ + "static/media/cancel-booking.0d0aea27.png";